import { ChangeDetectionStrategy, Component, input } from '@angular/core'

import {
  DetailedPermissions,
  Permissions,
} from '@flowx/designer/modules/workspaces/shared/workspace.utils'

import { FlxNavMenuItemComponent } from './nav-menu-item.component'
import { NavMenu } from './nav-menu.dictionary'

@Component({
  selector: 'flx-nav-menu',
  templateUrl: './nav-menu.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FlxNavMenuItemComponent],
})
export class FlxNavMenuComponent {
  showBackButton = input<boolean>(false)
  items = input<NavMenu>([])
  /** An uppercase title above the entries, such as "Organization settings". */
  heading = input<string>('')
  userAccessRights = input.required<DetailedPermissions>()
  permissions = input<Permissions>({})
}
